import { colors } from 'theme'

export const defaultThemeStyles = {
    preview: colors.blackLight,
    wallLine: colors.greyLight,
    tooltip: colors.cloud,
}
